var styles = {"tabNavigation":"TabNavigation-module_tabNavigation__x9mj0","list":"TabNavigation-module_list__9fnr8","tabNavigationItemContainer":"TabNavigation-module_tabNavigationItemContainer__o0slJ"};

export { styles as default };
